import React, {useEffect, useRef, useState} from 'react';

import {AssignEditorDropdown} from 'components/AssignEditorDropdown/AssignEditorDropdown';
import Button from 'components/Button/Button';
import Text from 'components/Text/Text';
import './AssignPageEditor.scss';
import {useGlobalState} from 'hooks/useGlobalState';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import {assignPubEditorACS} from 'pages/pubPagesView/store/requests';
import {setModalAC} from 'store/modal/modalSlice';

export const AssignPageEditor = () => {
  const dispatch = useSetGlobalState();
  const {singlePub} = useGlobalState((state) => state.pubPage);
  const [selectedUser, setSelectedUser] = useState<{name: string; id: number | null}>({name: '', id: null});
  const pubEditorRef = useRef<HTMLInputElement>(null);

  const handleCancel = () => dispatch(setModalAC(null));

  const handleAssign = () => {
    if (singlePub && selectedUser.id) {
      const data = {pubId: singlePub.id, userId: selectedUser.id};

      dispatch(assignPubEditorACS(data));
      handleCancel();
    }
  };

  useEffect(() => {
    if (selectedUser.id && pubEditorRef.current) pubEditorRef.current.value = selectedUser.name;
  }, [selectedUser]);

  return (
    <div className="assign-page-editor">
      <Text tag="h4">Add new page editor</Text>
      <AssignEditorDropdown pubEditorRef={pubEditorRef} setSelectedUser={setSelectedUser} />
      <div className="assign-page-editor__buttons">
        <Button variant="text-white" onClick={handleCancel}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleAssign} disabled={!selectedUser.id}>
          Add editor
        </Button>
      </div>
    </div>
  );
};
